import { api } from '../../api';

import {
  fetchComponents,
  fetchImages,
  fetchInspectionsList,
  fetchInspectionsListByUser,
  fetchSegments,
  patchCarImage,
  patchComponentData,
  patchDefect,
  patchFinishInspection,
  patchStartInspection,
  removeCarImage,
  removeDefect,
} from './fetchInspection';

export const inspectionApi = api.injectEndpoints({
  endpoints: (build) => ({
    fetchInspectionsList: fetchInspectionsList(build),
    fetchInspectionsItem: fetchInspectionsListByUser(build),
    fetchSegments: fetchSegments(build),
    patchStartInspection: patchStartInspection(build),
    fetchImages: fetchImages(build),
    patchCarImage: patchCarImage(build),
    removeCarImage: removeCarImage(build),
    fetchComponents: fetchComponents(build),
    patchDefect: patchDefect(build),
    removeDefect: removeDefect(build),
    patchFinishInspection: patchFinishInspection(build),
    patchComponentData: patchComponentData(build),
  }),
  overrideExisting: false,
});

export const {
  useLazyFetchInspectionsListQuery,
  useLazyFetchInspectionsItemQuery,
  useLazyFetchSegmentsQuery,
  usePatchStartInspectionMutation,
  useLazyFetchImagesQuery,
  usePatchCarImageMutation,
  useRemoveCarImageMutation,
  useLazyFetchComponentsQuery,
  usePatchDefectMutation,
  useRemoveDefectMutation,
  usePatchFinishInspectionMutation,
  usePatchComponentDataMutation,
} = inspectionApi;
